import * as React from 'react'
import BlogItem, { BlogPost } from '../components/BlogItem'
import { Flex } from 'rebass'
import Helmet from 'react-helmet'

interface Props {
  data: {
    allMarkdownRemark: {
      edges: { node: BlogPost }[]
    }
  }
}

class WritingPage extends React.PureComponent<Props, {}> {
  render() {
    const posts = this.props.data
      ? (this.props.data.allMarkdownRemark.edges || []).map(n => n.node)
      : []
    return (
      <Flex flexDirection={'column'} width={'100%'} alignItems={'center'}>
        <Helmet
          title={`Writing about tech, prod. mgt., politics, etc. | brandon paquette`}
        />
        {posts.map(p => <BlogItem post={p} />)}
      </Flex>
    )
  }
}

export default WritingPage

export const pageQuery = graphql`
  query BlogIndexQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          id
          wordCount {
            sentences
          }
          fields {
            slug
          }
          excerpt
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/writing.tsx